module.exports = __webpack_public_path__ + "static/img/cgal5.9756ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal5.png
// module id = evm1
// module chunks = 1